import { useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

const OPEN_CONTACT_FORM_SEARCH_PARAM = 'openContactForm'

export const useOpenContactFormFromSearchParam = (
  handleOpen: () => void,
): void => {
  const searchParams = useSearchParams()
  const isInitialized = useRef(false)

  useEffect(() => {
    if (
      isInitialized.current ||
      searchParams.get(OPEN_CONTACT_FORM_SEARCH_PARAM) !== 'true'
    ) {
      return
    }

    isInitialized.current = true
    handleOpen()
  }, [handleOpen, searchParams])
}
